$(document).ready(function () {
  
  //   // Header scroll effect
  //   const $header = $(".bc-header");

  //   // Check scroll position on page load
  //   function checkScrollPosition() {
  //     const scrollTop = $(window).scrollTop();
  //     if (scrollTop > 50) {
  //       $header.addClass("scrolled");
  //     } else {
  //       $header.removeClass("scrolled");
  //     }
  //   }

  //   // Check on page load
  //   checkScrollPosition();

  //   // Check on scroll
  //   $(window).on("scroll", function () {
  //     checkScrollPosition();
  //   });

  // Scroll Animation System
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px 0px 0px",
  };

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("bc-animate--visible");
      }
    });
  }, observerOptions);

  // Observe all animated elements
  //   const animatedElements = [];

  $(".bc-animate").each(function () {
    // animatedElements.push(this);

    // If element is in header, trigger animation immediately
    if ($(this).closest(".bc-header").length > 0) {
      // Add a small delay to make it visible
      setTimeout(() => {
        $(this).addClass("bc-animate--visible");
      }, 100);
    } else {
      // Use Intersection Observer for other elements
      observer.observe(this);
    }
  });

  // Trigger animations for elements already in viewport on page load
  setTimeout(function () {
    $(".bc-animate").each(function () {
      const $element = $(this);

      // Skip if already visible
      if ($element.hasClass("bc-animate--visible")) {
        return;
      }

      const elementTop = $element.offset().top;
      const elementBottom = elementTop + $element.outerHeight();
      const viewportTop = $(window).scrollTop();
      const viewportBottom = viewportTop + $(window).height();

      // Only trigger if element is clearly in viewport (no tolerance)
      if (elementBottom > viewportTop && elementTop < viewportBottom) {
        $element.addClass("bc-animate--visible");
      }
    });
  }, 500);
});
